import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Building2, Scale, Server, Globe } from 'lucide-react';

export const MentionsLegales = () => (
    <div className="min-h-screen bg-sand" data-testid="mentions-legales-page">
        <div className="max-w-3xl mx-auto px-4 py-12 sm:py-16">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-jungle/60 hover:text-jungle mb-8 transition-colors" data-testid="back-home-link">
                <ArrowLeft className="w-4 h-4" /> Retour a l'accueil
            </Link>

            <h1 className="font-heading font-bold text-3xl sm:text-4xl text-jungle mb-10">Mentions Legales</h1>

            <div className="space-y-10 text-jungle/80 text-sm leading-relaxed">
                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <Building2 className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">Editeur du site</h2>
                    </div>
                    <div className="pl-7 space-y-1">
                        <p><strong>Raison sociale :</strong> PRIXDEAL</p>
                        <p><strong>Siege social :</strong> CENTRA 307, 94586 RUNGIS CEDEX</p>
                        <p><strong>Adresse secondaire :</strong> 1 Rue de la Corderie, 94550 Chevilly-Larue</p>
                        <p><strong>Email :</strong> contact@prix-deal.fr</p>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <Server className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">Hebergement</h2>
                    </div>
                    <div className="pl-7 space-y-1">
                        <p>Le site est heberge par des services cloud professionnels assurant la disponibilite, la securite et la performance de la plateforme.</p>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <Scale className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">Propriete intellectuelle</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <p>L'ensemble des contenus (textes, images, logos, graphismes, icones, sons, logiciels) presentes sur le site prix-deal.fr sont proteges par les lois francaises et internationales relatives a la propriete intellectuelle.</p>
                        <p>Toute reproduction, representation, modification, publication ou adaptation de tout ou partie des elements du site, quel que soit le moyen ou le procede utilise, est interdite sans autorisation ecrite prealable de PRIXDEAL.</p>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <Globe className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">Responsabilite</h2>
                    </div>
                    <div className="pl-7 space-y-2">
                        <p>PRIXDEAL s'efforce d'assurer l'exactitude et la mise a jour des informations diffusees sur le site. Toutefois, PRIXDEAL ne peut garantir l'exactitude, la precision ou l'exhaustivite des informations mises a disposition.</p>
                        <p>PRIXDEAL decline toute responsabilite pour toute imprecision, inexactitude ou omission portant sur des informations disponibles sur le site.</p>
                        <p>Les prix affiches sur le site sont indicatifs et susceptibles d'evoluer. Les prix definitifs sont ceux confirmes lors de la validation de la commande.</p>
                    </div>
                </section>

                <section>
                    <div className="flex items-center gap-2 mb-3">
                        <Scale className="w-5 h-5 text-leaf" />
                        <h2 className="font-heading font-semibold text-lg text-jungle">Droit applicable</h2>
                    </div>
                    <div className="pl-7">
                        <p>Les presentes mentions legales sont soumises au droit francais. En cas de litige, les tribunaux francais seront seuls competents.</p>
                    </div>
                </section>
            </div>

            <div className="mt-12 pt-8 border-t border-jungle/10 flex flex-wrap gap-4 text-xs text-jungle/50">
                <Link to="/cgv" className="hover:text-jungle transition-colors">CGV</Link>
                <Link to="/politique-confidentialite" className="hover:text-jungle transition-colors">Politique de confidentialite</Link>
            </div>
        </div>
    </div>
);
